const isInactiveSql = (sql) =>
  !sql || sql === " AND 1=0" || String(sql).trim() === ""

/**
 * Service-without-sales queries need the sales side unrestricted when only
 * service filters are active (anti-join against all sales records).
 */
export const resolveDealerVaultSqlClauses = (
  sqlService,
  sqlSales,
  { neverPurchased, nevSerPrevPurch }
) => {
  const bothInactive = isInactiveSql(sqlService) && isInactiveSql(sqlSales)

  const serviceSql = bothInactive
    ? ""
    : isInactiveSql(sqlService)
    ? " AND 1=0"
    : sqlService

  let salesSql = bothInactive
    ? ""
    : isInactiveSql(sqlSales)
    ? " AND 1=0"
    : sqlSales

  if (
    neverPurchased &&
    !nevSerPrevPurch &&
    !isInactiveSql(serviceSql) &&
    isInactiveSql(salesSql)
  ) {
    salesSql = " AND 1=1"
  }

  return { sqlService: serviceSql, sqlSales: salesSql }
}

export const bigQueryURL = (
  nevSerDateRangePrevSer,
  neverPurchased,
  nevSerPrevPurch,
  nevSerDateRange
) => {
  const bigQueryURL = {
    url: "",
    csv: "",
  }
  const notExcludeQuery = !neverPurchased && !nevSerPrevPurch

  const excludeSalesVehicleQuery = !neverPurchased && nevSerPrevPurch

  const excludeServiceVehicleQuery = neverPurchased && !nevSerPrevPurch

  const excludeSalesServiceQuery = neverPurchased && nevSerPrevPurch

  const includeSalesNeverServiceQuery = !!nevSerDateRange

  const includeServiceNeverServiceQuery = !!nevSerDateRangePrevSer

  if (includeServiceNeverServiceQuery) {
    bigQueryURL.url = "getDealerVaultCountFromBQServiceNoServiceInDateRange"
    bigQueryURL.csv = "getDealerVaultListServiceNoServiceInDateRangeCSV"
  } else if (includeSalesNeverServiceQuery) {
    bigQueryURL.url = "getDealerVaultCountFromBQSalesNeverService"
    bigQueryURL.csv = "getDealerVaultListSalesNeverServiceCSV"
  } else if (notExcludeQuery) {
    bigQueryURL.url = "getDealerVaultCountFromBigQuery"
    bigQueryURL.csv = "getDealerVaultListCSV"
  } else if (excludeSalesVehicleQuery) {
    // Previously purchased (sales) without matching service
    bigQueryURL.url = "getDealerVaultCountServiceFromBigQuery"
    bigQueryURL.csv = "getDealerVaultListServiceCSV"
  } else if (excludeServiceVehicleQuery) {
    // Previously serviced without matching sales (never purchased)
    bigQueryURL.url = "getDealerVaultCountSalesFromBigQuery"
    bigQueryURL.csv = "getDealerVaultListSalesCSV"
  } else if (excludeSalesServiceQuery) {
    bigQueryURL.url = "getDealerVaultCountBothFromBigQuery"
    bigQueryURL.csv = "getDealerVaultListBothCSV"
  }
  return bigQueryURL
}
